<template>
    <v-row class="asset-stats-chart">
        <v-col cols="12" md="4">
            <h3 class="d-flex justify-center mb-3">{{ $t('profits.title') }}</h3>
            <p class="d-flex justify-center">{{ $t('profits.subtitle') }}</p>
            <apexchart class="d-flex justify-center" type=donut width=413 :options="optionsProfitContribution"
                :series="seriesProfitContribution" />
        </v-col>
        <v-col cols="12" md="4">
            <h3 class="d-flex justify-center mb-3">{{ $t('losses.title') }}</h3>
            <p class="d-flex justify-center">{{ $t('losses.subtitle') }}</p>
            <apexchart class="d-flex justify-center" type=donut width=413 :options="optionsLossesContribution"
                :series="seriesLossesContribution" />
        </v-col>
        <v-col cols="12" md="4">
            <h3 class="d-flex justify-center mb-3">{{ $t('market.title') }}</h3>
            <p class="d-flex justify-center">{{ $t('market.subtitle') }}</p>
            <apexchart class="d-flex justify-center" type=donut width=413 :options="optionsMarketDistribution"
                :series="seriesMarkets" />
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "AssetStats",
    data() {
        return {
            // Options
            optionsProfitContribution: {
                colors: ['rgba(0, 247, 132, 1)', 'rgb(0,179,247)', 'rgb(136,0,247)', 'rgb(208,0,247)'],
                labels: [],
            },
            optionsLossesContribution: {
                colors: ['rgba(0, 247, 132, 1)', 'rgb(0,179,247)', 'rgb(136,0,247)', 'rgb(208,0,247)'],
                labels: [],
            },
            optionsMarketDistribution: {
                colors: ['rgba(0, 247, 132, 1)', 'rgb(0,179,247)', 'rgb(136,0,247)', 'rgb(208,0,247)'],
                labels: [],
            },

            //Series
            seriesProfitContribution: [],
            seriesLossesContribution: [],
            seriesMarkets: [],
        };
    },
    mounted() {
        this.setData();
    },
    watch: {
        '$store.state.book.trades': function () {
            this.setData();
        }
    },
    methods: {
        setData() {
            this.setContribution();
        },
        setContribution() {
            let mapProfit = {};
            let mapLosses = {};
            let mapMarkets = {};

            let labelsProfit = [];
            let labelsLosses = [];
            let labelsMarkets = [];
            this.seriesProfitContribution = [];
            this.seriesLossesContribution = [];
            this.seriesMarkets = [];

            let copyOfTrades = this.$store.state.book.trades.slice();

            copyOfTrades.forEach((trade) => {
                // Monetary Contribution
                if (!(trade.asset.ticker in mapProfit) && trade.netProfit > 0)
                    mapProfit[trade.asset.ticker] = trade.netProfit;
                else if (!(trade.asset.ticker in mapLosses) && trade.netProfit <= 0)
                    mapLosses[trade.asset.ticker] = trade.netProfit;
                else if (trade.netProfit > 0)
                    mapProfit[trade.asset.ticker] = ((mapProfit[trade.asset.ticker] * 1) + trade.netProfit);
                else
                    mapLosses[trade.asset.ticker] = ((mapLosses[trade.asset.ticker] * 1) + trade.netProfit);

                // Market Distribution
                if (trade.asset.market != null) {
                    if (!(trade.asset.market.name in mapMarkets))
                        mapMarkets[trade.asset.market.name] = 1;
                    else
                        mapMarkets[trade.asset.market.name] = ((mapMarkets[trade.asset.market.name] * 1) + 1);
                }
            });

            for (let asset in mapProfit) {
                labelsProfit.push(asset);
                this.seriesProfitContribution.push(mapProfit[asset]);
            }
            for (let asset in mapLosses) {
                labelsLosses.push(asset);
                this.seriesLossesContribution.push(Math.abs(mapLosses[asset]));
            }
            for (let market in mapMarkets) {
                labelsMarkets.push(market);
                this.seriesMarkets.push(mapMarkets[market]);
            }

            this.optionsProfitContribution = {
                theme: {
                    mode: this.$store.state.currentTheme == "dark" ? "dark" : "light"
                },
                noData: {
                    text: 'No data for the current filter',
                    align: 'center',
                    verticalAlign: 'middle',
                    style: {
                        color: '#111111',
                        fontSize: '21px',
                        fontFamily: 'Ubuntu, sans-serif',
                    }
                },
                labels: labelsProfit,
                colors: ['rgb(0,85,50)', 'rgb(36,120,81)', 'rgb(0,196,105)', 'rgba(0, 247, 132, 1)', '#95f9ca'],
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `$ ${(val === undefined) ? val : val.toFixed(2)}`;
                        },
                        title: {
                            formatter: function (asset) {
                                return asset;
                            }
                        }
                    }
                },
            };
            this.optionsLossesContribution = {
                theme: {
                    mode: this.$store.state.currentTheme == "dark" ? "dark" : "light"
                },
                noData: {
                    text: 'No data for the current filter',
                    align: 'center',
                    verticalAlign: 'middle',
                    style: {
                        color: '#111111',
                        fontSize: '21px',
                        fontFamily: 'Ubuntu, sans-serif',
                    }
                },
                labels: labelsLosses,
                colors: ['rgb(67,11,0)', '#b22400', '#d76e00', '#b28000'],
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `-$ ${(val === undefined) ? val : val.toFixed(2)}`;
                        },
                        title: {
                            formatter: function (asset) {
                                return asset;
                            }
                        }
                    }
                },
            };
            this.optionsMarketDistribution = {
                theme: {
                    mode: this.$store.state.currentTheme == "dark" ? "dark" : "light"
                },
                noData: {
                    text: 'No data for the current filter',
                    align: 'center',
                    verticalAlign: 'middle',
                    style: {
                        color: '#111111',
                        fontSize: '21px',
                        fontFamily: 'Ubuntu, sans-serif',
                    }
                },
                labels: labelsMarkets,
                colors: ['rgb(0,85,50)', 'rgb(36,120,81)', 'rgb(0,196,105)', 'rgba(0, 247, 132, 1)', '#95f9ca'],
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `${val} trade(s)`;
                        },
                        title: {
                            formatter: function (market) {
                                return market;
                            }
                        }
                    }
                },
            };
        },
    },
}
</script>



<style lang="scss">
.app {
    .asset-stats-chart {
        .apexcharts-text {
            fill: var(--v-white-base);
        }

        .apexcharts-legend-text {
            color: var(--v-mainBlack-base) !important;
        }
    }
}
</style>
